export { StudentSettingsProfilePage } from "./StudentSettingsProfilePage"
export type {
    StudentProfileSettingsField,
    StudentSettingsProfilePageProps,
    UIStudentProfileCatalogs,
    UIStudentProfileSettings,
} from "./StudentSettingsProfilePage"
